import React from 'react'

function NewFactures() {
    return (
        <div>NewFactures</div>
    )
}

export default NewFactures